import { useSelector } from 'react-redux';

import { AppState } from '../../app.types';
import { useSelectorCurrentProductId } from '../../state';
import { NotificationsData } from './notifications.types';

export function useSelectorNotifications () {
    return useSelector<AppState, NotificationsData>((state) => {
        return state.notifications.data ?? [];
    });
}

/**
 * Notifications are filtered by product id in the FE as per prev implementation.
 */
export function useSelectorNotificationsWithProductId () {
    const productId = useSelectorCurrentProductId();
    const notifications = useSelectorNotifications();

    return notifications.filter((item) => {
        if (item.productIds.includes(productId)) return item;
    });
}
